import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.jsx';
import { ErrorFallback } from './wizard/StubScreen.jsx';
import './styles/globals.css';

// Sentry — runtime error tracking. Включается только если DSN передан через env.
// Без DSN init молча пропускается, никаких ошибок.
// Тикет: https://www.notion.so/34b19875cbb881dfa49fd819e8253e39
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    // ⛔ REPLAY ВЫКЛЮЧЕН ЦЕЛИКОМ (`s946.d3`). На каждой ошибке он уносил положения ползунков и
    // выбранные чипы — атрибуты DOM он не маскирует, кроме `title`/`placeholder`. Для отладки
    // хватает стека, шага из адреса и крошек. Держит машина: `src/sentryPrivacy.test.js`.
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.1,
    release: import.meta.env.VITE_RELEASE_SHA || undefined,
    environment: import.meta.env.MODE,
  });
}

// Экран падения — `src/wizard/StubScreen.jsx`: строки `ERROR_COPY` (`s945.d1`), вид по борду
// заглушек Stub Screens v2 (тикет `3eb19875cbb881bb9a04e503ee488d31`).

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
